import { ReduxStore } from 'store/types';

function getAllThreadsIsLoading(state: ReduxStore): boolean {
  return state.intervention.getAllThreads.config.isLoading;
}

export default getAllThreadsIsLoading;
